<template>
  <div class="accounts-groups-list scrollable">
      <div class="list">
        <div class="groups">
          <div class="group" v-for="(item, index) in groups" :key="index" @click="selectService(item)">
            <div class="picture" :style="imageStyle(item)" :alt="item.name"></div>
            <div class="name">
              {{ gettext(item.name) }}
            </div>
            <i ref="icon"
              class="material-icons" tabindex="-1" role="button"> chevron_right </i>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import GettextMixin from '@paiuolo/pai-vue-gettext/mixins/GettextMixin'

export default {
  name: 'AccountsGroupsList',
  mixins: [
    GettextMixin
  ],
  props: {
    groups: {
      type: Array,
      default: null
    }
  },
  methods: {
    imageStyle (group) {
      let style = {}
      if (group) {
        if (group.picture) {
          style['background-image'] = 'url(\'' + group.picture + '\')'
        } else {
          style['background-color'] = 'silver'
        }
      }
      return style
    },
    selectService (group) {
      if (group.is_unsubscribed) {
        alert(this.gettext('You already unsubscribed from') + ' ' + group.name)
      } else {
        // console.log('selecting group', group)
        this.$emit('groupSelected', group)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../scss/accounts.theme";

.accounts-groups-list {
  @include accounts-font;
  @include accounts-scrollable-container;

  cursor: pointer;
  margin-top: 16px;
  background-color: $secondary;
  color: $on-secondary;
  border-radius: 3px;
  height: 240px;

  .list {
    margin-bottom: 8px;
    clear: both;
    overflow: hidden;

    .groups {
      overflow: hidden;

      .group {
        text-align: left;
        overflow: hidden;
        border-radius: 3px;
        padding: 8px;
        height: 42px;
        line-height: 42px;
        position: relative;

        > * {
          box-sizing: border-box;
        }

        .picture {
          height: 42px;
          width: 42px;
          background-repeat: no-repeat;
          background-size: contain;
          display: inline-block;
          float: left;
          padding-left: 8px;
          width: 20%;
        }
        .name {
          height: 42px;
          line-height: 42px;
          display: inline-block;
          padding: 0 8px;
          float: left;
          width: 70%;
        }
        .material-icons {
          line-height: 42px;
          float: left;
          width: 10%;
          text-align: right;
        }
      }
      .group:hover {
        background-color: #dedede;
      }
    }
  }
}
</style>
